<script setup lang="ts">
import { AlertCircle, CheckCircle2, Info, TriangleAlert, X } from 'lucide-vue-next'
import { useUiStore } from '../../stores/ui'

const ui = useUiStore()
const icons = { success: CheckCircle2, error: AlertCircle, info: Info, warning: TriangleAlert }
</script>

<template>
  <Teleport to="body">
    <div class="toast-region" aria-live="polite">
      <TransitionGroup name="toast">
        <div v-for="item in ui.toasts" :key="item.id" class="toast" :class="`toast-${item.tone}`">
          <component :is="icons[item.tone]" :size="20" aria-hidden="true" />
          <span>{{ item.message }}</span>
          <button class="toast-close" type="button" @click="ui.dismissToast(item.id)">
            <X :size="16" />
          </button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>
